export default "__VITE_ASSET__U_wB2ZWF__"